import { render, staticRenderFns } from "./RealTimeSituation.vue?vue&type=template&id=2765fdd0&"
import script from "./RealTimeSituation.vue?vue&type=script&lang=js&"
export * from "./RealTimeSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports